<template>
  <div class="box">
    <div class="heading">
      <h1 class="title">
        {{ teammate.full_name }}
      </h1>
    </div>
    <div class="content teammate-content">
      <img v-show="imageUrl" class="profile-photo" :src="imageUrl">
      <p class="description">{{ teammate.description }}</p>
      <social-icons
        :scale=1.5
        :website="teammate.links.website"
        :twitter="teammate.links.twitter"
        :github="teammate.links.github"
        :instagram="teammate.links.instagram"
        :linkedin="teammate.links.linkedin"
        :google-plus="teammate.links.google_plus"
        :facebook="teammate.links.facebook"
      ></social-icons>
    </div>
  </div>
</template>

<script>
import SocialIcons from '@/components/SocialIcons'
export default {
  name: 'teammate',
  props: {
    teammate: {
      type: Object,
      required: true
    },
    githubUsername: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      imageUrl: null
    }
  },
  created () {
    this.axios.get(this.userUrl).then(res => {
      this.imageUrl = res.data.avatar_url
    })
    .catch(e => {
      console.log(e)
    })
  },
  computed: {
    userUrl () {
      return 'https://api.github.com/users/' + this.githubUsername
    }
  },
  components: {
    SocialIcons
  }
}
</script>



// WEBPACK FOOTER //
// Teammate.vue?80e4f726